import Video from './Video';

export type {VideoProps} from './types';
export default Video;
